import { Dropdown, Menu } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  ClockCircleOutlined,
  SignatureOutlined,
  MoreOutlined,
} from '@ant-design/icons';
import { showToastError } from 'src/utilities/errortoast';
import { updateEncounter } from '../../store/actions/encounter';
import { CustomIcons } from 'src/icons/Custom.icon';
import { useAuth, usePermissionEntitlements } from '@frontegg/react';
import { analytics } from 'src/services';

export const HumanScribeStatus = ({
  encounterDetailsSlice,
  encounterPhase,
  humanScribeStatus,
  storedParams,
}) => {
  const dispatch = useDispatch();
  const { user } = useAuth();

  const { scribePractitioners } = useSelector((state) => state.encounterState);

  const { isEntitled: isAssignToScribeEntitled } =
    usePermissionEntitlements('assign-to-scribe');

  const hasAssignableScribes =
    isAssignToScribeEntitled && scribePractitioners?.length > 0;

  const updateEncounterStatus = async (key) => {
    if (encounterDetailsSlice?.in_visit_status != 'completed') {
      showToastError('Encounter is not completed');
      return;
    }
    analytics.track('Clicked Human Scribe Status', {
      encounter_id: encounterDetailsSlice?.encounter_id,
      email: user?.email,
    });
    await dispatch(
      updateEncounter(
        encounterDetailsSlice?.encounter_id,
        encounterPhase,
        {
          encounter_status: key.key,
        },
        storedParams
      )
    );
  };

  const assignEncounterToScribe = async (key) => {
    await dispatch(
      updateEncounter(
        encounterDetailsSlice?.encounter_id,
        encounterPhase,
        {
          assigned_scribe_id: key.key,
        },
        storedParams
      )
    );
  };

  const statusSubmenu = (
    <Menu
      onClick={updateEncounterStatus}
      placement="bottomRight"
      style={{
        padding: '0px',
        overflowX: 'hidden',
        border: 'none',
        boxShadow: 'none',
      }}
    >
      {humanScribeStatus?.['aura_status_mapping']
        ?.filter((status) => !status.disable)
        ?.map((status) => (
          <Menu.Item
            key={status.status_id}
            icon={CustomIcons[status.status_id]}
            style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
          >
            <span>{status.status_name}</span>
          </Menu.Item>
        ))}
    </Menu>
  );

  const assigneeSubmenu = (
    <Menu onClick={assignEncounterToScribe}>
      {scribePractitioners?.map((practitioner) => (
        <Menu.Item
          key={practitioner.practitioner_id}
          icon={<SignatureOutlined color="#000" />}
          style={{ textAlign: 'left', fontSize: '13px' }}
        >
          {practitioner.practitioner_name}
        </Menu.Item>
      ))}
    </Menu>
  );

  // Main menu with submenus for specific items
  const menu = (
    <Menu style={{ width: '150px' }}>
      {encounterDetailsSlice?.in_visit_status === 'completed' && (
        <Menu.SubMenu
          key="status"
          title="Status"
          icon={<ClockCircleOutlined />}
          popupOffset={[4, 0]}
        >
          {statusSubmenu}
        </Menu.SubMenu>
      )}
      {/* <Menu.Item key="assignee" icon={<UserOutlined />}>Assignee</Menu.Item>
            <Menu.Item key="priority" icon={<BarChartOutlined />}>Priority</Menu.Item>
            <Menu.Item key="labels" icon={<TagOutlined />}>Labels</Menu.Item>
            <Menu.Item key="estimate" icon={<WarningOutlined />}>Estimate</Menu.Item>
            <Menu.Item key="cycle" icon={<ClockCircleOutlined />}>Cycle</Menu.Item>
            <Menu.Item key="project" icon={<AppstoreOutlined />}>Project</Menu.Item> */}
      {hasAssignableScribes && (
        <Menu.SubMenu
          key="assignee"
          title="Assign to"
          icon={<SignatureOutlined />}
          popupOffset={[4, 0]}
        >
          {assigneeSubmenu}
        </Menu.SubMenu>
      )}
    </Menu>
  );

  return (
    (encounterDetailsSlice?.in_visit_status === 'completed' ||
      hasAssignableScribes) && (
      <Dropdown overlay={menu} trigger={['hover']} placement="bottomRight">
        <MoreOutlined className="cursor-pointer text-lg" />
      </Dropdown>
    )
  );
};
